import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getCashFlows, closeRegisters, closeClosingInProgressRegisters } from 'actions/EntityActions';
import { clearFormInput } from 'actions/FormActions';
import { showError, showSnackbar } from 'actions/CommonActions';
import WithRouter from 'custom/withRouter';
import LOOKUP from 'constants/lookup';
import { cashRegisterListCrumb } from 'utils/breadcrumbInfo';
// Basic Components
import CustomButton from 'screens/components/basic/Button';
import Pagination from 'screens/components/basic/Pagination';
import Grid from 'screens/components/basic/Grid';
import CardSimple from 'screens/components/basic/CardSimple';
import DialogHeader from 'screens/components/basic/DialogHeader'
import Button from 'screens/components/basic/Button';
import PageHeaderWithButton from 'screens/components/basic/PageHeaderWithButton';
// Advanced Components
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';
import SearchFields from './searchFields';

const pageName = "CashRegisterList";
class CashRegisterList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dialogConfirmCloseRegister: false,
            activePage: 1,
            itemsPerPage: 25,
            orderBy: 'DESC',
            sortBy: 'CashInDate',
            dialogConfirmCloseCIPRegister: false
        };

        this.sort = this.sort.bind(this);
        this.openCloseRegistersDialog = this.openCloseRegistersDialog.bind(this);
        this.closeRegisters = this.closeRegisters.bind(this);
        this.closeCloseRegistersDialog = this.closeCloseRegistersDialog.bind(this);
    }

    componentWillMount() {
        this.getCashFlows();
    }

    componentWillReceiveProps(newProps) {
        if (newProps.closeRegistersSaveSuccess !== undefined && this.props.closeRegistersSaveSuccess !== newProps.closeRegistersSaveSuccess) {
            if (newProps.closeRegistersSaveSuccess) {
                this.closeRegistersSuccess();
            }
            else if (newProps.closeRegistersSaveError) {
                this.closeRegistersFailure();
            }
        }
    }

    redirectToAddCashRegister = () => {
        this.props.navigate("/admin/cashregister/add");
    }

    redirectToEditCashRegister = (id) => {
        this.props.navigate(`/admin/cashregister/edit/${id}`);
    }

    redirectOpenedOrders = () => {
        this.props.navigate("/admin/orders/open");
    }

    openCloseRegistersDialog() {
        if (!this.props.selectedRows) {
            this.props.showSuccess("You have to Select least one register in order to use Close Selected Opened Register Button")
        } else if (this.props.selectedRows) {
            this.setState({ dialogConfirmCloseRegister: true });
        }
    }

    openCloseCIRRegistersDialog = () => {
        this.setState({ dialogConfirmCloseCIPRegister: true });
    }

    closeCloseRegistersDialog() {
        this.setState({ dialogConfirmCloseRegister: false });
    }

    closeCloseCIPRegistersDialog = () => {
        this.setState({ dialogConfirmCloseCIPRegister: false });
    }

    closeRegisters() {
        if (this.props.selectedRows) {
            let cashFlowIds = [];
            // if select all, we will push all existing cash flows to the list
            if (this.props.selectedRows == "all") {
                this.props.cashFlows.map((c) => {
                    cashFlowIds.push(parseInt(c.id));
                });
            } else {
                this.props.selectedRows.map((rowIndex) => {
                    cashFlowIds.push(parseInt(this.props.cashFlows[rowIndex].id));
                });
            }

            if (cashFlowIds.length > 0) {
                this.props.closeRegisters({ cashFlowIds: cashFlowIds }, this.props.branchId);
            }
            this.closeCloseRegistersDialog();
        }
    }

    closeRegistersFailure = () => {
        this.props.showError(LOOKUP.cashregister.messages.cashRegistersCloseError);
    }

    closeRegistersSuccess = () => {
        this.getCashFlows();
        this.props.showSuccess(LOOKUP.cashregister.messages.cashRegistersClosed);
        this.props.clearFormInput('closeRegistersSaveSuccess');
    }

    changePage = (e) => {
        this.resetPagination(e);
        this.getCashFlows(e);
    }

    search = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getCashFlows);
    }

    cleanSearch = () => {
        this.props.clearFormInput('CashRegisterListFirstNameFilter');
        this.props.clearFormInput('CashRegisterListLastNameFilter');
        this.props.clearFormInput('CashRegisterListClockInFilter');
        this.props.clearFormInput('CashRegisterListStationFilter');
        this.props.clearFormInput('CashRegisterListStatus');

        this.setState(pState => {
            return {
                ...pState,
                activePage: 1,
                sortBy: "CashInDate",
                orderBy: "DESC"
            };
        }, () => this.getCashFlows());
    }

    getCashFlows = (page) => {
        const model = {
            branchId: this.props.branchId || 0,
            employeeFirstName: this.props.employeeFirstName || "",
            employeeLastName: this.props.employeeLastName || "",
            status: this.props.statusFilter || "None",
            cashInDate: this.props.dateFilter || null,
            station: this.props.stationFilter || "",
            orderBy: this.state.orderBy,
            sortBy: this.state.sortBy,
            page: page || this.state.activePage,
            itemsPerPage: this.state.itemsPerPage
        }

        this.props.getCashFlows(model);
    }

    resetPagination = (page) => {
        this.setState({ activePage: page ? page : 1 });
    }

    sort(sortBy) {
        this.setState(prevState => {
            return {
                ...prevState,
                orderBy: prevState.orderBy === 'DESC' ? 'ASC' : 'DESC',
                sortBy: sortBy
            }
        }, this.getCashFlows);
    }

    closeClosingInProgressRegisters = () => {
        this.props.closeClosingInProgressRegisters({ branchId: this.props.branchId });
        this.closeCloseCIPRegistersDialog()
    }

    render() {
        const listCashFlows = (this.props.cashFlows || []).map((item, index) => {
            return {
                CashInDate: item.date,
                EmployeeFirstName: (<Link to={`/admin/cashregister/edit/${item.id}`}>{item.employeeFullName}</Link>),
                Station: item.station,
                ExpectedBalance: `$ ${item.expectedBalance ? item.expectedBalance.toFixed(2) : '0.00'}`,
                Balance: `$ ${item.balance ? item.balance.toFixed(2) : '0.00'}`,
                LossBalance: `$ ${item.lossBalance ? item.lossBalance.toFixed(2) : '0.00'}`,
                Status: (item.status == "ClosingInProgress") ? "Closing in Progress" : item.status,
                Icons: (
                        <CustomButton
                            type="IconViewButton"
                            id={`buttonViewCashflow-${index}`}
                            mini={true}
                            onTouchTap={() => this.redirectToEditCashRegister(item.id)} />
                )
            };
        });

        return (
            <Grid headerContent={cashRegisterListCrumb} >
                <PageHeaderWithButton title={LOOKUP.menu.admin.items.cashregister.text}>
                    <Button
                        type="RaisedButton"
                        label="Close Selected Opened Register"
                        id="buttonCloseSelectedRegister"
                        primary={true}
                        onTouchTap={this.openCloseRegistersDialog} 
                        className="mb-2"
                    />
                    <br/>
                    <Button
                        type="RaisedButton"
                        label="Force Close All Close in Progress Register"
                        id="buttonCloseInProgressRegister"
                        primary={true}
                        onTouchTap={this.openCloseCIRRegistersDialog}
                        className="mb-2"
                    />
                </PageHeaderWithButton>
                <SearchFields
                    pageName={pageName}
                    cleanSearch={this.cleanSearch}
                    search={this.search}
                    openCloseRegistersDialog={this.openCloseRegistersDialog}
                />
                <CardSimple>
                    <GenericTable
                        compName="cashRegistersListTable"
                        tableHeaderClassName="table-products-header"
                        tableBodyClassName="table-products"
                        multiSelectable={true}
                        enableSelectAll={true}
                        displaySelectAll={true}
                        adjustForCheckbox={true}
                        displayRowCheckbox={listCashFlows.tableRow ? false : true}
                        selectable={true}
                        columns={LOOKUP.cashregister.tableColumns}
                        rows={listCashFlows}
                        orderBy={this.state.orderBy}
                        sortBy={this.state.sortBy}
                        sort={this.sort}
                        stripedRows={true}
                    />
                    <Pagination
                        length={this.props.cashFlowsListTotal || 0}
                        itemsPerPage={this.state.itemsPerPage}
                        activePage={this.state.activePage}
                        onPageChange={this.changePage}
                        maxButtons={4}
                    />
                </CardSimple>

                <DialogInput
                    title={<DialogHeader text="Close Registers" />}
                    actions={[
                        <CustomButton
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={this.closeCloseRegistersDialog} />,
                        <CustomButton
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            primary={true}
                            onTouchTap={this.closeRegisters} />]}
                    modal={true}
                    open={this.state.dialogConfirmCloseRegister}>
                    This action will only affect registers that have the "Opened" status. Are you sure you want to do that?
                </DialogInput>
                <DialogInput
                    bodyStyle={{ color: "red" }}
                    title={<DialogHeader text="Close Registers" />}
                    actions={[
                        <CustomButton
                            key={1}
                            type="CancelButton"
                            name="buttonCancelRemoveItem"
                            className="btn-space"
                            label={LOOKUP.common.cancel.text}
                            onTouchTap={this.closeCloseCIPRegistersDialog} />,
                        <CustomButton
                            key={2}
                            name="buttonRemoveItem"
                            label="Confirm"
                            labelStyle={{ color: "white" }}
                            buttonStyle={{ backgroundColor: "red" }}
                            onTouchTap={this.closeClosingInProgressRegisters} />]}
                    modal={true}
                    open={this.state.dialogConfirmCloseCIPRegister}><p style={{ color: "black", fontSize: "1.7rem" }}>
                        <b style={{ color: "red" }}>CAUTION!</b> This action will affect <b style={{ color: "red" }}>all registers</b> that have the status of <b style={{ color: "red" }}>'Closing in Progress'</b>. If you choose to proceed, <b style={{ color: "red" }}>it will force the registers to a 'Closed' status, potentially causing end-of-day cash count discrepancies.</b> Are you sure you want to proceed with this action?</p>
                </DialogInput>
            </Grid>
        );
    }
}

function mapStatetoProps(state) {
    return {
        cashFlows: state.entity.cashFlowsList,
        cashFlowsListTotal: state.entity.cashFlowsListTotal,
        selectedRows: state.form["cashRegistersListTableSelectedRows"],
        closeRegistersSaveSuccess: state.form["closeRegistersSaveSuccess"],
        closeRegistersSaveError: state.form["closeRegistersSaveError"],
        employeeFirstName: state.form["CashRegisterListFirstNameFilter"],
        employeeLastName: state.form["CashRegisterListLastNameFilter"],
        dateFilter: state.form["CashRegisterListClockInFilter"] ? new Date(state.form['CashRegisterListClockInFilter']) : null,
        stationFilter: state.form["CashRegisterListStationFilter"],
        statusFilter: state.form["CashRegisterListStatus"],
        branchId: state.common.branchId
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getCashFlows: (page, itemsPerPage, branchId) => dispatch(getCashFlows(page, itemsPerPage, branchId)),
        closeRegisters: (model, branchId) => dispatch(closeRegisters(model, branchId)),
        closeClosingInProgressRegisters: (model) => dispatch(closeClosingInProgressRegisters(model)),
        showError: (message) => dispatch(showError(message)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showSuccess: (message) => dispatch(showSnackbar(message))
    };
}

export default connect(mapStatetoProps, mapDispatchToProps)(WithRouter(CashRegisterList));
